// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/services/warehouseService.js
// =============================================================================

import axiosClient from "../../../../api/axiosClient";
//import axiosClient from "../../../../api/axiosClient";


// =============================================================================
// GET WAREHOUSE LIST
// =============================================================================

export async function getWarehouseList() {
  try {
    console.log("DEBUG: Calling Warehouse List API");

    const response = await axiosClient.get(
      "/api/ppe/material-flow/warehouse/master/list"
    );

    console.log("DEBUG: Warehouse API Response:", response);
    console.log("DEBUG: Warehouse API Data:", response.data);

    return response.data;

  } catch (error) {
    console.error("DEBUG: Warehouse API Error:", error);
    console.error("DEBUG: Error Response:", error.response);
    console.error("DEBUG: Request URL:", error.config?.baseURL, error.config?.url);

    throw error;
  }
}

export async function getWarehouseList_old() {

  const response =
    await axiosClient.get(

      "/api/ppe/material-flow/api/ppe/material-flow/warehouse/master/list"
    );

  return response.data;
}